/* ==========================================================================
   Hot Lips - client change requests (05/09/2026)
   Additive behaviour only. No Kalles core JS was modified.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     [#15] Cart drawer: "-" at quantity 1 removes the line item.
     Reuses the theme's own removal path (.js_cart_rem -> changeItem(id,0))
     so AJAX, totals, cart count, drawer refresh and empty state all behave
     exactly as they already do. No second request is issued.
     Capture phase so it runs before Kalles' delegated .plus/.minus handler.
  --------------------------------------------------------------------- */
  function qtyOf(item) {
    var input = item.querySelector('input.qty, .qty_cart_js');
    var v = input ? parseInt(input.value, 10) : NaN;
    return isNaN(v) ? 1 : v;
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('.minus');
    if (!minus) return;
    var item = minus.closest('.js_cart_item');
    if (!item) return;
    if (qtyOf(item) > 1) return;

    var remove = item.querySelector('.js_cart_rem');
    if (!remove) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (minus.dataset.hlBusy === '1') return;
    minus.dataset.hlBusy = '1';
    setTimeout(function () { delete minus.dataset.hlBusy; }, 1200);
    remove.click();
  }, true);

  function labelMinus(root) {
    (root || document).querySelectorAll('.js_cart_item').forEach(function (item) {
      var minus = item.querySelector('.quantity .minus');
      if (!minus) return;
      var willRemove = qtyOf(item) <= 1;
      minus.classList.toggle('hl-will-remove', willRemove);
      minus.setAttribute('aria-label', willRemove ? 'Remove this item' : 'Decrease quantity');
    });
  }
  document.addEventListener('DOMContentLoaded', function () { labelMinus(); });
  document.addEventListener('cart:refresh', function () { setTimeout(labelMinus, 60); });
  document.addEventListener('cart:updated', function () { setTimeout(labelMinus, 60); });
  var cartObserverTarget = null;
  function watchCart() {
    var el = document.querySelector('.nt_js_cart, #nt_cart_canvas');
    if (!el || el === cartObserverTarget) return;
    cartObserverTarget = el;
    new MutationObserver(function () { labelMinus(el); }).observe(el, { childList: true, subtree: true });
    labelMinus(el);
  }
  document.addEventListener('DOMContentLoaded', watchCart);
  setTimeout(watchCart, 1200);

  /* ---------------------------------------------------------------------
     [#4] About Us: show ~2 lines, reveal the rest with an arrow toggle.
     The existing markup is wrapped in place - no content is duplicated,
     truncated or removed, and the full text stays in the DOM.
  --------------------------------------------------------------------- */
  function initAboutUs() {
    document.querySelectorAll('.about_us_txt:not([data-hl-collapse])').forEach(function (box) {
      box.setAttribute('data-hl-collapse', '1');
      if (box.scrollHeight < 140) return;

      var body = document.createElement('div');
      body.className = 'hl-collapse__body';
      body.id = 'hl-about-body-' + Math.random().toString(36).slice(2, 8);
      while (box.firstChild) body.appendChild(box.firstChild);
      box.appendChild(body);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hl-collapse__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', body.id);
      btn.innerHTML = '<span class="hl-collapse__label">Read more</span><span class="hl-collapse__arrow" aria-hidden="true"></span>';
      box.appendChild(btn);
      box.classList.add('hl-collapse');

      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.querySelector('.hl-collapse__label').textContent = open ? 'Read less' : 'Read more';
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initAboutUs);
  document.addEventListener('shopify:section:load', function () { setTimeout(initAboutUs, 40); });

  /* ---------------------------------------------------------------------
     [#10] Prefer the "Large" size on load.
     Kalles renders size options as <li class="nt-swatch" data-value="...">
     backed by a hidden <select name="id">. Clicking the option drives the
     theme's own variant pipeline, so the real variant id, the displayed
     price and the Add to cart payload all update normally.
     Skipped when the URL already names a variant (respects shared links)
     and when the shopper has already chosen something.
  --------------------------------------------------------------------- */
  function findLarge(form) {
    var lis = form.querySelectorAll('li.nt-swatch, li.swatch_pr_item');
    for (var i = 0; i < lis.length; i++) {
      var v = (lis[i].getAttribute('data-value') || '') + ' ' + (lis[i].getAttribute('data-escape') || '');
      if (/large/i.test(v)) return lis[i];
    }
    var radios = form.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) {
      if (/large/i.test(radios[j].value || '')) return radios[j];
    }
    return null;
  }

  function preferLarge(attempt) {
    if (/[?&]variant=/.test(window.location.search)) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.hlLarge === '1') return;

    var target = findLarge(form);
    if (!target) {
      if ((attempt || 0) < 8) return setTimeout(function () { preferLarge((attempt || 0) + 1); }, 250);
      return;
    }
    if (target.classList.contains('is-selected') || target.checked) { form.dataset.hlLarge = '1'; return; }
    form.dataset.hlLarge = '1';
    target.click();
  }
  document.addEventListener('DOMContentLoaded', function () { preferLarge(0); });

  /* ---------------------------------------------------------------------
     [#6] Footer groups open by default.
     Kalles gates the footer accordions with .footer_collapse_true on the
     wrapper. Flipping that class uses the theme's own mechanism, so the
     mobile toggles keep working if the merchant re-enables them later.
  --------------------------------------------------------------------- */
  function openFooterGroups() {
    document.querySelectorAll('.footer__top_wrap.footer_collapse_true').forEach(function (el) {
      el.classList.remove('footer_collapse_true');
      el.classList.add('footer_collapse_false');
    });
  }
  document.addEventListener('DOMContentLoaded', openFooterGroups);
  document.addEventListener('shopify:section:load', function () { setTimeout(openFooterGroups, 40); });

})();
